import "core-js/modules/es.array.push.js";
import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const gameVuex = createNamespacedHelpers("game");
const walletVuex = createNamespacedHelpers("wallet");
const taskVuex = createNamespacedHelpers("task");
import particles from "particles.js";
import { Mining } from "@assets/js/Mining.js";
Vue.use(particles);
export default {
  name: "index",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo"]),
    ...gameVuex.mapState(["gameProgress", "gameData", "upgradeResultInfo"]),
    ...walletVuex.mapState(["isMobile"]),
    ...taskVuex.mapState(["taskInfo", "timerObjs"]),
    devicePixelRatio() {
      return window.devicePixelRatio;
    },
    isUpgradeResultInfoInit() {
      return !this.upgradeResultInfo.show && !this.gameData.isContinue && !this.gameData.isQuickUpgradeLoading;
    }
  },
  data() {
    const menuBtns = {
      task: {
        title: "Task",
        page: "/rewards?tab=2",
        reward: null
      },
      botcode: {
        title: "BotCode",
        page: "/botcode",
        reward: null
      },
      turn: {
        title: "Slot",
        page: "/slotMachine",
        reward: null
      }
    };
    return {
      mintBotPercent: 0,
      miningObj: null,
      mintBotSimpleCount: 0,
      storageInfo: {
        capacity: 0,
        stock: {
          coins: 0,
          percent: 0
        }
      },
      menuBtns
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          // this.setWowAnim();
          this.calcMintBot();
        }
      },
      deep: true,
      immediate: true
    },
    isUpgradeResultInfoInit: {
      handler(bool) {
        if (bool) {
          this.gameData.totalResource.coin = 0;
          this.gameData.totalResource.spins = 0;
          this.gameData.totalResource.ticket = 0;
          this.gameData.totalResource.stock = 0;
          this.gameData.isNextUpgrade = false;
        }
      },
      deep: true,
      immediate: true
    },
    "gameProgress.currentLevel": {
      async handler(newLevel, oldLevel) {
        if (oldLevel !== undefined && oldLevel !== null && newLevel != oldLevel) {
          this.gameData.isNextUpgrade = true;
          this.upgradeResultInfo.show = true;
          this.upgradeResultInfo.anim.step1 = true;
          await new Promise(resolve => setTimeout(resolve, 300));
          this.upgradeResultInfo.anim.step2 = true;
          await new Promise(resolve => setTimeout(resolve, 300));
          this.setWowAnim();
          this.upgradeResultInfo.anim.step3 = true;
          this.setConfetti();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...gameVuex.mapActions(["quickUpgradeFnc"]),
    setConfetti() {
      this.confetti({
        particleCount: 15,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        },
        zIndex: 2000,
        colors: ["9cfd09", "3edf46", "0ccf66", "39580e", "a0fe07"]
      });
      this.confetti({
        particleCount: 15,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        },
        zIndex: 2000,
        colors: ["9cfd09", "3edf46", "0ccf66", "39580e", "a0fe07"]
      });
    },
    async calcMintBot() {
      const res = await this.$http.post("/mining/info", {
        simple: 0
      });
      if (!res) {
        return;
      }
      if (res.code > 0) {
        return;
      }
      this.miningObj = new Mining(res.data);
      this.calcMining(null, false);
      this.poolMinning();
    },
    calcMining(res) {
      const calcRes = this.miningObj.reset(res);
      const stock = calcRes.stock;
      this.storageInfo.stock = stock;
    },
    poolMinning() {
      clearTimeout(this.timerObjs.botPage.miningTimer);
      this.timerObjs.botPage.miningTimer = setTimeout(async () => {
        this.mintBotSimpleCount++;
        const mintBotSimpleMax = 20;
        if (this.mintBotSimpleCount >= mintBotSimpleMax) {
          const res = await this.$http.post("/mining/info", {
            simple: 0
          });
          if (res.code > 0) {
            return;
          }
          if (res) {
            this.calcMining(res, false);
          }
          this.mintBotSimpleCount = 0;
        } else {
          this.calcMining(null, false);
        }
        this.poolMinning();
      }, 1000);
    },
    upgradePageLink() {
      this.hapticFeedback();
      this.$nextTick(() => {
        this.$router.push("/upgrade");
      });
    },
    async onQuickUpgrade() {
      this.upgradeResultInfo.show = true;
      await this.quickUpgradeFnc();
    },
    onUpgradeResultInfoClose() {
      this.upgradeResultInfo.show = false;
    },
    onQuickUpgradeDetail() {
      // this.upgradeResultInfo.show = false;
      this.$nextTick(() => {
        this.$router.push("/upgrade");
      });
    }
  },
  beforeDestroy() {
    console.log(6666);
    clearTimeout(this.timerObjs.botPage.miningTimer);
  },
  mounted() {
    this.setWowAnim();
    this.$nextTick(particlesJS.load("particles-js", "/particlesjs-config.json"));
  }
};